import BaseService from '@/network/base-service'

class ExameService extends BaseService {
  constructor () {
    super(`${process.env.VUE_APP_API_BASE_URL}/paciente`)
  }
  getExames (datas) {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/documentos/exames?dataInicio=${datas.dataInicio.toISOString()}&dataTermino=${datas.dataTermino.toISOString()}`,
      {
        method: 'GET'
      }
    )
  }
  getFilterExam () {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/documentos/examespordia`,
      {
        method: 'GET'
      }
    )
  }
  getArquivoExame (payload) {
    return this.get(
      `paciente/documentos/exames/${payload.documento}?unidade=${payload.unidade}`,
      { responseType: 'blob' }
    )
  }
  getArquivoLaudo (dados) {
    let uri = `paciente/documentos/laudos/${dados.codigoItemAtendimento}`
    if (dados.codigoDocumento) {
      uri += `?codigoDocumento=${dados.codigoDocumento}`
    }
    return this.get(uri, {
      responseType: 'blob'
    })
  }
  getAnexo (codigoAnexo, codigoItemAtendimento) {
    return this.get(`paciente/documentos/anexo/${codigoAnexo}?item=${codigoItemAtendimento}`, {
      responseType: 'blob'
    })
  }
  solicitarImagens (codigoItemAtendimento) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/documentos/exames/solicitarimagens`,
      {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: `"${codigoItemAtendimento}"`
      }
    )
  }
}

export default new ExameService()
